export { default } from './FeatureCard';
export type { FeatureCardProps } from './FeatureCard';
